export const APP_API_ENDPOINT = "https://utas-srp.uac.edu.au/api";